import { DefaultDisplayValue } from 'app/enums';
import React, { PropsWithChildren, FC, memo, useMemo } from 'react';

interface HumanizeOrdinalFormatProps {
  order?: number;
  hideSuffix?: boolean;
}

const pluralRules = new Intl.PluralRules('en-US', { type: 'ordinal' });
const suffixes = {
  zero: 'th',
  one: 'st',
  two: 'nd',
  few: 'rd',
  other: 'th',
  many: 'th',
};

const HumanizeOrdinalFormatComponent: FC<PropsWithChildren<HumanizeOrdinalFormatProps>> = ({
  order,
  hideSuffix,
}) => {
  const value = useMemo(() => {
    if (!order || hideSuffix) {
      return DefaultDisplayValue.DASH;
    }

    const rule = pluralRules.select(order);
    return `${order}${suffixes[rule]}`;
  }, [hideSuffix, order]);

  return <>{value}</>;
};
export const HumanizeOrdinalFormat = memo(HumanizeOrdinalFormatComponent);
